import React from "react";
import { SelectInput } from "@pericles/framework-frontend";

import { useAuth } from "../hooks/auth";

export function TenantSwitcher({
  showLabel = true,
  selectClassName = "w-64",
}: {
  showLabel?: boolean;
  selectClassName?: string;
}): JSX.Element | null {
  const { tenants, activeTenantId, setActiveTenant, loading } = useAuth();

  if (loading) return null;
  if (!tenants || tenants.length === 0) return null;

  const handleChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const next = event.target.value;
    if (!next || next === activeTenantId) return;
    try {
      await setActiveTenant(next);
    } catch (error) {
      console.error("Failed to switch tenant", error);
    }
  };

  const activeLabel = tenants.find((tenant) => tenant.id === activeTenantId)?.name ?? "Select tenant";

  return (
    <div className="flex flex-col gap-1">
      {showLabel ? <span className="text-xs font-semibold uppercase text-muted-foreground">Tenant</span> : null}
      <SelectInput
        className={selectClassName}
        value={activeTenantId ?? ""}
        onChange={handleChange}
        disabled={tenants.length <= 1}
        aria-label={`Active tenant: ${activeLabel}`}
      >
        <option value="" disabled>
          Select tenant
        </option>
        {tenants.map((tenant) => (
          <option key={tenant.id} value={tenant.id}>
            {tenant.name}
          </option>
        ))}
      </SelectInput>
    </div>
  );
}
